import { Component } from '@angular/core';
import { SearchableEntityServiceFactory } from '../../../../../shared/services/searchable-entity/searchable-entity-service-factory';
import { MaintainReportButtonService } from '../../services/maintain-report-button.service';
import { DetailedEntityDataEditorService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { DetailedEntityBackendService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-backend.service';
import { MaintainReportDataService } from '../../services/maintain-report-data.service';
import { DetailedEntityActionService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-action.service';

@Component({
  selector: 'lfwms-maintain-report-search',
  templateUrl: './maintain-report-search.component.html',
  styleUrls: ['./maintain-report-search.component.css']
})
export class MaintainReportSearchComponent {

  public serviceFactory: SearchableEntityServiceFactory;

  constructor(protected dataService: MaintainReportDataService,
    protected actionService: DetailedEntityActionService,
    protected buttonService: MaintainReportButtonService,
    protected dataEditor: DetailedEntityDataEditorService,
     protected backendService: DetailedEntityBackendService) {
    this.serviceFactory = new SearchableEntityServiceFactory(dataService, actionService, backendService, dataEditor, buttonService);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/maintain-report/maintain-report-home/maintain-report-search/maintain-report-search.component.ts